/**
 * Returns true when the given product slug is c-ppt2 and the user's products
 * array contains a coaching SKU for that product (SKU starts with "CH-C-PPT2").
 *
 * @param {string} productSlug  - slug extracted from the URL or product data
 * @param {Array}  userProducts - user.products array from Redux state
 * @returns {boolean}
 */
export function hasCoachingForProduct(productSlug, userProducts = []) {
  if (productSlug !== 'c-ppt2') return false;
  return userProducts.some(p => p.SKU?.toUpperCase().startsWith('CH-C-PPT2') && !p.SKU?.toUpperCase().endsWith('CALL'));
}
